import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import { useSelector } from 'react-redux';
import TableHead from '@mui/material/TableHead';
import { GridSection } from '../../../Episode.Styled';
import TableContainer from '@mui/material/TableContainer';
import {
  CustomTableRow,
  TableFooterData,
  TableHeadingData,
} from './transportPdfCommonUtils';

export const CostTableRow = () => {
  const transportPdfData = useSelector((state) => state?.transportPdfForm);
  const {
    trnQtyMlgAct,
    trnQtyTMAct,
    trnQtyTMOTAct,
    trnQtyMlgEst,
    trnQtyTMEst,
  } = transportPdfData || {};

  return (
    <GridSection mt={1} mx={2} container spacing={1}>
      <Grid item xs={12}>
        <TableContainer component={Paper}>
          <Table border={2}>
            <TableHead>
              <TableHeadingData
                heading1="Estimated Costs"
                heading2="Actual Costs"
              />
              <CustomTableRow
                label="Staff Time"
                rate="$00.00 each hour"
                quantityEst={trnQtyTMEst}
                quantityAct={trnQtyTMAct}
                amount="$0.00"
              />

              <CustomTableRow
                label="Mileage"
                rate="$00.00 per mile"
                quantityEst={trnQtyMlgEst}
                quantityAct={trnQtyMlgAct}
                amount="$0.00"
              />

              <CustomTableRow
                label="Overtime"
                rate="$00.00 per hour"
                quantityEst={0}
                quantityAct={trnQtyTMOTAct}
                amount="$0.00"
              />

              <TableFooterData
                labelEst="Total Estimate Costs"
                amountEst="$0.00"
                labelAct="Total Actual Costs"
                amountAct="$0.00"
              />
            </TableHead>
          </Table>
        </TableContainer>
      </Grid>
    </GridSection>
  );
};
